import React, { useContext, useState } from 'react'
import { LanguageContext } from './context/LanguageContext';


const Step2 = ({ formData, handleChange, handleNext,handlePrev }) => {
    const [errorMessage, setErrorMessage] = useState("");

    // Function to check if all required fields are filled
    const isFormValid = () => {
        const requiredFields = [
            "purposeOfTransactions",
            "annualVolume",
            "transactionsPerMonth",
            "currencies",
        ];

        // if (["ACH Direct Debit", "Cheque"].includes(formData.paymentMethod)) {
        //     requiredFields.push("bankName", "bankAddress", "accountNumber", "abaNumberRoutingCode","accountType");
        // }


        return requiredFields.every((field) => formData[field] && formData[field].trim() !== "");
    };

    // Handle next button click
    const handleNextClick = () => {
        if (isFormValid()) {
            handleNext();
        } else {
            setErrorMessage("Please fill in all required fields.");
        }
    };


    const {language} = useContext(LanguageContext)
    return (
        <div>
            <h1 className="text-center text-2xl font-semibold mb-8">{language==='en'?'Purpose of Payment':'Propósito del pago'}</h1>
            <div className="flex gap-3">
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Purpose of Transactions (Please be specific)':'Propósito de las transacciones (sea específico)'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="purposeOfTransactions"
                        onChange={handleChange}
                        value={formData.purposeOfTransactions}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Annual Volume':'Volumen Anual'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="number"
                        name="annualVolume"
                        onChange={handleChange}
                        value={formData.annualVolume}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Estimated # of Transactions/Month':'# estimado de transacciones/mes'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="number"
                        name="transactionsPerMonth"
                        onChange={handleChange}
                        value={formData.transactionsPerMonth}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
            </div>
            <div className='w-full'>
                <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Select currencies':'Seleccionar monedas'} <span className='text-red-600'>*</span></h6>
                <input
                    type="text"
                    name="currencies"
                    onChange={handleChange}
                    value={formData.currencies}
                    className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                    required
                />
            </div>


                {language==='en'?(
                    <div>
            <h1 className="text-center text-2xl font-semibold mb-8">{language==='en'?'Payment Methods':'Métodos de pago'}</h1>
            <div className=" mb-4 flex items-center gap-4 justify-center">
                {["ACH Direct Debit", "Cheque", "Transfer", "Not Applicable"].map((method) => (
                    <label key={method} className="flex items-center space-x-2">
                        <input
                            type="radio"
                            name="paymentMethod"
                            value={method}
                            checked={formData.paymentMethod === method}
                            onChange={handleChange}
                            className="text-blue-600 focus:ring-blue-500"
                        />
                        <span>{method}</span>
                    </label>
                ))}
            </div>
                    {["ACH Direct Debit", "Cheque"].includes(formData.paymentMethod) && (
                <div className="">
                    <div className='flex gap-8'>
                        <div className='w-full'>
                            <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Bank Name':'Nombre del banco'} <span className='text-red-600'>*</span></h6>
                            <input
                                type="text"
                                name="bankName"
                                onChange={handleChange}
                                value={formData.bankName}
                                className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                                required
                            />
                        </div>
                        <div className='w-full'>
                            <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Bank Address (City, State)':'Dirección del banco (ciudad, estado)'} <span className='text-red-600'>*</span></h6>
                            <input
                                type="text"
                                name="bankAddress"
                                onChange={handleChange}
                                value={formData.bankAddress}
                                className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                                required
                            />
                        </div>
                    </div>
                    <div className='flex gap-8'>
                        <div className='w-full'>
                            <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Account Number':'Número de cuenta'} <span className='text-red-600'>*</span></h6>
                            <input
                                type="text"
                                name="accountNumber"
                                onChange={handleChange}
                                value={formData.accountNumber}
                                className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                                required
                            />
                        </div>
                        <div className='w-full'>
                            <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'ABA Number / Routing Code':'Número ABA / Código de ruta'} <span className='text-red-600'>*</span></h6>
                            <input
                                type="text"
                                name="abaNumberRoutingCode"
                                onChange={handleChange}
                                value={formData.abaNumberRoutingCode}
                                className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                                required
                            />
                        </div>
                    </div>
                    <div>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Account Type':'Tipo de cuenta'} <span className='text-red-600'>*</span></h6>
                    {["Checking", "Savings"].map((method) => (
                    <label key={method} className="flex items-center space-x-2">
                        <input
                            type="radio"
                            name="accountType"
                            value={method}
                            checked={formData.accountType === method}
                            onChange={handleChange}
                            className="text-blue-600 focus:ring-blue-500"
                            required
                        />
                        <span>{method}</span>
                    </label>
                ))}
                    </div>
                </div>
            )}
                </div>
            ):""}

            <div className='flex gap-5'>
                {errorMessage && (
                    <p className="text-red-600 text-sm mt-4">{errorMessage}</p>
                )}

                <button
                    className={`flex justify-center w-full py-2 mt-8 rounded-lg  bg-secondary text-primary font-bold hover:bg-secondary/80
                        }`}
                    onClick={handlePrev}
                >
                    {language==='en'?'Previous':'Previo'}
                </button>
                <button
                    className={`flex justify-center w-full py-2 mt-8 rounded-lg ${isFormValid() ? "bg-primary text-white hover:bg-primary/90" : "bg-gray-300 text-gray-500 cursor-not-allowed"
                        }`}
                    onClick={handleNextClick}
                    disabled={!isFormValid()}
                >
                    {language==='en'?'Next':'Próximo'}
                </button>
            </div>
        </div>
    )
}

export default Step2
